import React, { useEffect, useState } from "react";

import {
  BarChart,
  Bar,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

import SubTitle from "./SubTitle";
// import { MdOutlineCalendarToday } from "react-icons/md";
// import { LuClock4 } from "react-icons/lu";
import { FaCircle } from "react-icons/fa6";

// const data = [
//   {
//     name: "12:00",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 10,
//     failed: 20,
//   },
//   {
//     name: "12:05",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 15,
//     failed: 5,
//   },
//   {
//     name: "12:10",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 12,
//     failed: 18,
//   },
//   {
//     name: "12:15",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 10,
//     failed: 20,
//   },
//   {
//     name: "12:20",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 17,
//     failed: 13,
//   },
//   {
//     name: "12:25",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 12,
//     failed: 10,
//   },
//   {
//     name: "12:30",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 18,
//     failed: 12,
//   },
//   {
//     name: "12:35",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 8,
//     failed: 52,
//   },
//   {
//     name: "12:40",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 11,
//     failed: 9,
//   },
//   {
//     name: "12:45",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 14,
//     failed: 16,
//   },
//   {
//     name: "12:50",
//     date: "7 Sep 2024",
//     time: "12.16",
//     success: 20,
//     failed: 10,
//   },
// ];

const RecentExecutions = (props) => {
  const { selectedPipeline, pipelinesWithLogs } = props;
  const [recentData, setRecentData] = useState([]);

  useEffect(() => {
    if (pipelinesWithLogs) {
      const transformedData = pipelinesWithLogs.map((pipeline) => {
        const totalSuccess = pipeline.pipeline_logs.filter(log => log.status === "success").length;
        const totalFailed = pipeline.pipeline_logs.filter(log => log.status === "failure").length;

        const createdAt = new Date(pipeline.created_at);
        const date = createdAt.toLocaleDateString("en-GB", { year: 'numeric', month: 'long', day: 'numeric' });
        const time = createdAt.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' });

        return {
          name: pipeline.name,
          date: date,
          time: time,
          success: totalSuccess,
          failed: totalFailed,
        };
      });

      setRecentData(transformedData);
    }
  }, [pipelinesWithLogs]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { failed, success, name } = payload[0].payload;

      return (
        <div
          style={{
            position: "relative",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "7px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            color: "white",
            fontSize: "10px",
            width: "150px",
          }}
        >
          <p style={{ margin: 0, paddingBottom: 3 }}>{name}</p>
          <hr />
          <div className="py-1">
            {/* <div
            className="flex gap-1 items-center"
            style={{ paddingTop: "3px" }}
          >
            <span>
              <MdOutlineCalendarToday size={10} />
            </span>
            <span>{date}</span>
          </div>
          <div
            className="flex gap-1 items-center "
            style={{ paddingTop: "3px" }}
          >
            <span>
              <LuClock4 size={10} />
            </span>
            <span>{time}</span>
          </div> */}
            <div
              className="flex gap-1 items-center "
              style={{ paddingTop: "3px" }}
            >
              <span className="flex gap-1 items-center ">
                <span>
                  <FaCircle color="#E94848" />
                </span>
                <span>Failed :</span>
              </span>
              <span>{failed}</span>
            </div>
            <div
              className="flex gap-1 items-center "
              style={{ paddingTop: "3px" }}
            >
              <span className="flex gap-1 items-center ">
                <span>
                  <FaCircle color="#0BB783" />
                </span>
                <span>Success :</span>
              </span>
              <span>{success}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  console.log(recentData, "recent data");

  return (
    <div>
      <div>
        <SubTitle
          title={`Recent Executions - ${selectedPipeline}`}
          showDropdown={false}
          heading="Hourly"
        />
      </div>

      {recentData && recentData.length > 0 ? (
        <div className="p-3 min-h-20 h-64">
          <ResponsiveContainer width="100%" height={240}>
            <BarChart
              data={recentData}
              margin={{
                top: 20,
                right: 5,
                left: 5,
                bottom: 5,
              }}
              barSize={15}
            >
              <CartesianGrid stroke="#f5f5f5" strokeDasharray="0 0" />
              <XAxis
                axisLine={false}
                tickLine={false}
                tick={{
                  fill: "#9E9E9E",
                  fontSize: 9,
                }}
              // label={{
              //   value: "12:00 - 13:00",
              //   position: "bottom",
              //   offset: -5,
              //   fontSize: "10px",
              //   fill: "#9E9E9E",
              // }}
              // tickFormatter={(value) => (value === 5 ? "Custom Label" : "")}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                ticks={[]}
                tick={{
                  fill: "#9E9E9E",
                  fontSize: 9,
                }}
                className="text-xs text-[#9E9E9E]"
              />
              <text
                x={60} // Adjust this value to position it correctly
                y={160} // Adjust for vertical positioning
                textAnchor="middle"
                fill="#9E9E9E"
                fontSize="10px"
                transform="rotate(-90, 10, 150)" // Rotate the text to be vertical
              >
                Tasks
              </text>
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="success" stackId="a" fill="#00C49F" />
              <Bar dataKey="failed" stackId="a" fill="#FF4D4D" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="text-sm font-medium flex items-center justify-center h-64">
          No data available.
        </div>
      )
      }
    </div>
  );
};

export default RecentExecutions;
